module.exports = [
  {
    path: "/user",
    name: "用户中心",
    component: () => import("../../components/user/userMenu.vue"),
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: "orderMain/:flag",
        name: "我的订单",
        component: () => import("../../components/user/orderMain.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "myorderBack",
        name: "退货列表",
        component: () => import("../../components/user/myorder/myorderaBack.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "myorderReturn",
        name: "退款列表",
        component: () => import("../../components/user/myorder/myorderReturn.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "personal",
        name: "个人中心",
        component: () => import("../../components/user/personal.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "myAccount",
        name: "我的账户",
        component: () => import("../../components/user/myAccount.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "address",
        name: "收货地址",
        component: () => import("../../components/user/shipAddress.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "changePwd",
        name: "修改密码",
        component: () => import("../../components/user/changePwd.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "message",
        name: "系统消息",
        component: () => import("../../components/user/message.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "accountInfo",
        name: "账户信息",
        component: () => import("../../components/provider/accountInfo.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "accountBill",
        name: "账单管理",
        component: () => import("../../components/provider/accountBill.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "downMateBill",
        name: "配货单下载",
        component: () => import("../../components/provider/downMateBill.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "mateBill",
        name: "下载订单列表",
        component: () => import("../../components/provider/mateBill.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "uploadBook",
        name: "上传书目",
        component: () => import("../../components/provider/uploadBook.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "bookLog",
        name: "书目更新日志",
        component: () => import("../../components/provider/bookLog.vue"),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "bookDown",
        name: "书目下载",
        component: () => import("../../components/provider/bookDown.vue"),
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
];
